<template>
<div>
    <div class="dekstop-view">
        <div class="tableFixHead sticky2">
            <table>
                <thead>
                    <tr>
                        <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index" :style="loadStyle(index)">
                            <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                            <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                            <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                        </th>
                    </tr>
                </thead>
            </table>
        </div>
        <div class="content-sticky">
            <CRow>
                <CCol sm="12">
                    <div class="tableFixHead">
                        <table>
                            <tbody v-if="data.length == 0">
                                <tr>
                                    <td class="text-center" colspan="5">
                                        {{errors}}
                                    </td>
                                </tr>
                            </tbody>
                            <tbody v-else>
                                <tr v-for="(body, id) in data" :key="id">
                                    <td v-for="(item, index) in td" :key="index" :style="loadStyle(index)">
                                        <template v-if="item != 'action'">
                                            <template v-if="item[0].length == 1">
                                                <template v-if="body[item] == 'null' || body[item] == ''">
                                                    -
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'status'">
                                                        <div class="row no-gutters">
                                                            <div class="col-12 ellps">
                                                                <span class="font-weight-bold" :style="'font-size:12px;color:' + body.color">{{body.status}}</span>
                                                            </div>
                                                            <div :title="body.namaApprover" v-if="body.namaApprover != ''" class="col-12 ellps">
                                                                <span>by {{body.namaApprover}}</span>
                                                            </div>
                                                            <div v-if="body.tglApprove != ''" class="col-12 ellps">
                                                                <span>at {{body.tglApprove}}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'testing'">
                                                            <div class="row no-gutters">
                                                                <div :title="body.jenisTest" class="col-12 ellps">
                                                                    <span class="font-weight-bold" style="font-size:12px">{{body.jenisTest}}</span>
                                                                </div>
                                                                <div v-if="body.tanggalHasil != ''" class="col-12 ellps">
                                                                    <span>at {{body.tanggalHasil}}</span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'hasil'">
                                                                <div class="row no-gutters">
                                                                    <div :title="body.hasilRta" class="col-12 ellps text-center">
                                                                        <span class="font-weight-bold" style="font-size:12px">{{body.hasilRta}}</span>
                                                                    </div>
                                                                </div>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="item == 'file'" class="text-center">
                                                                    <img v-if="body.urlFile != '' && body.urlFile != 'null'" class="text-center" :src="downloadIcon" @click="direct(body.urlFile)" width="20px" height="20px" style="cursor:pointer"/>
                                                                    <span v-if="body.urlFile == '' || body.urlFile == 'null'">-</span>
                                                                </template>
                                                                <template v-else>
                                                                    <div :title="body[item]" class="col-12 p-0 ellps">
                                                                        {{body[item]}}
                                                                    </div>
                                                                </template>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <div class="row no-gutters">
                                                    <div :title="body.nama" class="col-12 ellps">
                                                        <span>{{body.nama}}</span>
                                                    </div>
                                                    <div class="col-12">
                                                        <span style="font-size:12px; color:grey">{{body.nik}}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </template>
                                        <template v-if="item == 'action' && body.tglApprove == ''">
                                            <CButton @click="goEdit(id)" class="btn btn-edit">View</CButton>
                                        </template>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </CCol>
            </CRow>
        </div>
    </div>
    <div class="mobile-view">
        <CRow class="mt-3">
            <CCol sm="12">
                <div>
                    <table class="table-responsive">
                        <thead>
                            <tr>
                                <th @click="clickThead(index)" style="cursor:pointer" v-for="(item, index) in th" :key="index">
                                    <span v-if="item != 'Action'" style="float:left">{{item}}</span>
                                    <span v-if="item == 'Action'" style="float:right">{{item}}</span>
                                    <img v-if="item != 'Action'" :src="sortIcon[index]" width="16px" height="16px" style="float:right"/>
                                </th>
                            </tr>
                        </thead>
                        <tbody v-if="data.length == 0">
                            <tr>
                                <td class="text-center" colspan="5">
                                    {{errors}}
                                </td>
                            </tr>
                        </tbody>
                        <tbody v-else>
                            <tr v-for="(body, id) in data" :key="id">
                                <td v-for="(item, index) in td" :key="index">
                                    <template v-if="item != 'action'">
                                        <template v-if="item[0].length == 1">
                                            <template v-if="body[item] == 'null' || body[item] == ''">
                                                -
                                            </template>
                                            <template v-else>
                                                <template v-if="item == 'status'">
                                                    <div class="row no-gutters">
                                                        <div class="col-12 ellps">
                                                            <span class="font-weight-bold" :style="'font-size:12px;color:' + body.color">{{body.status}}</span>
                                                        </div>
                                                        <div :title="body.namaApprover" v-if="body.namaApprover != ''" class="col-12 ellps">
                                                            <span>by {{body.namaApprover}}</span>
                                                        </div>
                                                        <div v-if="body.tglApprove != ''" class="col-12 ellps">
                                                            <span>at {{body.tglApprove}}</span>
                                                        </div>
                                                    </div>
                                                </template>
                                                <template v-else>
                                                    <template v-if="item == 'testing'">
                                                        <div class="row no-gutters">
                                                            <div :title="body.jenisTest" class="col-12 ellps">
                                                                <span class="font-weight-bold" style="font-size:12px">{{body.jenisTest}}</span>
                                                            </div>
                                                            <div v-if="body.tanggalHasil != ''" class="col-12 ellps">
                                                                <span>at {{body.tanggalHasil}}</span>
                                                            </div>
                                                        </div>
                                                    </template>
                                                    <template v-else>
                                                        <template v-if="item == 'hasil'">
                                                            <div class="row no-gutters">
                                                                <div :title="body.hasilRta" class="col-12 ellps text-center">
                                                                    <span class="font-weight-bold" style="font-size:12px">{{body.hasilRta}}</span>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <template v-else>
                                                            <template v-if="item == 'file'" class="text-center">
                                                                <img v-if="body.urlFile != '' && body.urlFile != 'null'" class="text-center" :src="downloadIcon" @click="direct(body.urlFile)" width="20px" height="20px" style="cursor:pointer"/>
                                                                <span v-if="body.urlFile == '' || body.urlFile == 'null'">-</span>
                                                            </template>
                                                            <template v-else>
                                                                <div :title="body[item]" class="col-12 p-0 ellps">
                                                                    {{body[item]}}
                                                                </div>
                                                            </template>
                                                        </template>
                                                    </template>
                                                </template>
                                            </template>
                                        </template>
                                        <template v-else>
                                            <div class="row no-gutters">
                                                <div :title="body.nama" class="col-12 ellps">
                                                    <span>{{body.nama}}</span>
                                                </div>
                                                <div class="col-12">
                                                    <span style="font-size:12px; color:grey">{{body.nik}}</span>
                                                </div>
                                            </div>
                                        </template>
                                    </template>
                                    <template v-if="item == 'action' && body.tglApprove == ''">
                                        <CButton @click="goEdit(id)" class="btn btn-edit">View</CButton>
                                    </template>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </CCol>
        </CRow>
    </div>
</div>
</template>

<script>

export default {
    props: ['data', 'th', 'td', 'styleTable', 'errors'],
    data() {
        return {
            sortIcon: [],
            downloadIcon: require('@/assets/menu/icon_download_excel.svg'),
        }
    },
    mounted() {
        this.iconLoad('unsort', 'none')
    },
    watch: {
    },
    methods: {
        clickThead(index) {
            this.$emit('sort', index)
            this.iconLoad('sort', index)
        },
        goEdit(id) {
            this.$emit('edit', id)
        },
        loadStyle(index) {
            return 'width:' + this.styleTable[index] + ';' + 'max-width:' + this.styleTable[index]
        },
        iconLoad(type, index) {
            this.sortIcon = []
            let length = this.th.length
            var i = 0
            if (type == 'sort') {
                for(i=0;i<length;i++) {
                    let onPush = ''
                    if(index == i) {
                        onPush = require('../assets/menu/sort_normal.svg')
                    } else {
                        onPush = require('../assets/menu/sort_active.svg')
                    }
                    this.sortIcon.push(onPush)
                }
            } else {
                for(i=0;i<length;i++) {
                    let onPush = require('../assets/menu/sort_active.svg')
                    this.sortIcon.push(onPush)
                }
            }
        },
        direct(link) {
            window.open(
            link,
            '_blank' // <- This is what makes it open in a new window.
            );
        },  
    },
}
</script>

<style scoped>
@media only screen and (max-width:1278px) {
  .dekstop-view {
      display: none;
  }
}
@media only screen and (min-width:1279px) {
  .mobile-view {
      display: none;
  }
}
table {
    width: 100%;
}
table thead tr {
    background-color: rgba(244, 244, 244, 1);
}
thead th {
    padding-top: 16px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 16px;
}
tbody td {
    padding-top: 8px;
    padding-bottom: 8px;
    padding-left: 10px;
    padding-right: 10px;
}
td,th {
    border: 1px solid rgba(238, 238, 238, 1);
    font-size: 14px;
}
.ellps {
    overflow-x: hidden !important;
    text-overflow: ellipsis;
    white-space: nowrap;
}
tr:nth-child(even) {
    background-color: rgba(252, 252, 252, 1);
}
div.sticky2 {
    position: -webkit-sticky;
    position: sticky;
    top: 105px;
    background-color: white;
    z-index: 1;
}
.content-sticky {
    background-color: white;
}
.btn-edit {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: white;
    color: black;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
.btn-edit:hover {
    border-radius: 4px;
    border: 1px solid rgba(154, 154, 154, 1);
    background-color: rgba(154, 154, 154, 1);
    color: white;
    font-size: 14px;
    font-weight: 600;
    width: 80px;
    height: 32px;
    float:right;
}
</style>